import React, { useCallback, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Building2, Loader2 } from 'lucide-react';
import { toast } from 'react-hot-toast';
import DocumentListWidget from '../../components/documents/DocumentListWidget';

const fields = [
  ['title', 'Ünvan'],
  ['taxOffice', 'Vergi Dairesi'],
  ['taxNumber', 'Vergi No'],
  ['phone', 'Telefon'],
  ['email', 'E-posta'],
  ['address', 'Adres']
];

const CompanyInfo = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadConfig = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get('/api/system');
      setConfig(data.data || data);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Şirket bilgileri alınamadı.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      loadConfig();
    }, 0);

    return () => window.clearTimeout(timer);
  }, [loadConfig]);

  const company = useMemo(() => config?.companyDetails || {}, [config]);
  const companyId = config?._id;

  if (loading) {
    return (
      <div className="flex min-h-[420px] items-center justify-center">
        <Loader2 size={28} className="animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-7xl space-y-6 p-6">
      <div>
        <h1 className="text-2xl font-black text-slate-900">Şirket Bilgileri</h1>
        <p className="text-sm font-medium text-slate-500">Şirket kapsamındaki evraklar ve temel kurumsal bilgiler</p>
      </div>

      <div className="grid gap-6 xl:grid-cols-[360px_1fr]">
        <div className="rounded-[2rem] border border-slate-100 bg-white p-6 shadow-sm">
          <div className="mb-5 flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-blue-600">
              <Building2 size={20} />
            </div>
            <div>
              <h2 className="text-lg font-black text-slate-800">{company.name || 'Şirket'}</h2>
              <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">Genel Ayarlar kaydı</p>
            </div>
          </div>

          <div className="space-y-3">
            {fields.map(([key, label]) => (
              <div key={key} className="rounded-2xl bg-slate-50 p-4">
                <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">{label}</p>
                <p className="mt-1 break-words text-sm font-bold text-slate-700">{company[key] || '-'}</p>
              </div>
            ))}
          </div>
        </div>

        {companyId ? (
          <DocumentListWidget category="COMPANY" parentResourceId={companyId} title="Şirket Evrak Matrisi" />
        ) : (
          <div className="rounded-[2rem] border border-slate-100 bg-white p-6 text-sm font-bold text-slate-400 shadow-sm">
            Şirket konfigürasyon kaydı bulunamadı.
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyInfo;
